import React, { useEffect } from "react";
import Icon1 from "../icons/Icon";
import Divider from "../layout/Divider";
import DropDown1 from "../dropdowns/DropDown1";
import TextField2 from "../textfields/TextField2";
import SecondaryButton from "../buttons/SecondaryButton";
import PrimaryButton from "../buttons/PrimaryButton";
import Space from "../layout/Space";
import { useState } from "react";
import { Timestamp } from "firebase/firestore";
import {
  createDoc,
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getRefFromId,
  getUserDataById,
  queryCollection,
} from "../models/DataFunctions";
import TextFieldEmail from "../textfields/TextFieldEmail";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { useSnackbar } from "notistack";
import sendEmailOrg from "../api/send/sendSmartEmailFolder";
import { useAppContext } from "../config/AppContext";
import createNewJob from "../api/create/createNewJob";
import createDocApi from "../api/database/createDocApi";
import SmallSpinner from "../loading/SmallSpinner";
import { set } from "date-fns";
import { useNavigate } from "react-router-dom";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { EasySwitch } from "../textfields/EasySwitch";
import DropDownGPT1X from "../dropdowns/DropDownGPT1X";
import DropDownGPT0X from "../dropdowns/DropDownGTP0X";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import { Spin } from "antd";
import { id } from "date-fns/locale";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3";
import dayjs from "dayjs";
import { isFolderClient } from "../hexagone/VisibilityHelpers";
import Modal1 from "./Modal1";
import TextField2T from "../textfields/TextField2T";
import { folder } from "jszip";
import sendSmartEmailFolder from "../api/send/sendSmartEmailFolder";
import sendSmartEmailInvoice from "../api/send/sendSmartEmailInvoice";
import updateDocApi from "../api/database/updateDocApi";
import { getOrgById } from "../models/OrgFunctions";
import Dropzone3 from "../dropzones/DropZone3";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary";
import getBookShelfUrls from "../api/presigned/getBookShelfUrls";
const EmailModal = ({
  folderData,
  invoiceData,
  orgData,
  onClose = (wanted = false) => {},
  for_expert,
  masterData,
  for_modif_thermal = false,
  for_xml = false,
  for_doc_request = false,
  selected_doc_names = [],
  selected_doc_ids = [],
  eventData = null,
  navigateWorkspace,
  workspaceData,
}) => {
  const [all_email_templates, setAllEmailTemplates] = useState([]);
  const [email_templates_options, setEmailTemplatesOptions] = useState([]);
  const [email_template_selected, setEmailTemplateSelected] = useState(null);
  const [all_receivers, setAllReceivers] = useState([]);
  const [receiver_options, setReceiverOptions] = useState([]);
  const [receiver_selected, setReceiverSelected] = useState(null);
  const [receiver_selected_object, setReceiverSelectedObject] = useState(null);
  const [bookshelf, setBookshelf] = useState([]);

  function add_master_email_cc(workspaceData, masterData) {
    if (workspaceData) {
      if (
        (masterData.notifications?.auto_add_cc_invoice_sign && invoiceData) ||
        (for_xml && masterData.notifications?.email_xml_requested)
      ) {
        return masterData.notifications?.emails || [];
      }
    }
    return [];
  }

  const [cc_emails, setCcEmails] = useState(
    workspaceData ? masterData.notifications?.emails : []
  );
  const [cc_emails_selected, setCcEmailsSelected] = useState(
    add_master_email_cc(workspaceData, masterData)
  );

  const [existing_emails, setExistingEmails] = useState([]);
  const [cc_emails_options, setCcEmailsOptions] = useState(
    workspaceData && masterData.notifications?.emails?.length > 0
      ? [
          {
            email: masterData.notifications?.emails[0],
            role: "client",
          },
        ]
      : []
  );
  const [dropped_files, setDroppedFiles] = useState([]);
  const [bcc_emails_options, setBccEmailsOptions] = useState([]);
  const [bcc_emails, setBccEmails] = useState([]);
  const [bcc_emails_selected, setBccEmailsSelected] = useState([]);

  const [object, setObject] = useState("");
  const [content, setContent] = useState("");
  const [reminder, setReminder] = useState(false);
  const [client, setClient] = useState(null);
  const [emails, setEmails] = useState([]);
  const [emails_options, setEmailsOptions] = useState([]);
  const [emails_selected, setEmailsSelected] = useState([]);
  const [gettingEmails, setGettingEmails] = useState(false);
  const [conductor_missed, setConductorMissed] = useState(false);
  const [openAddEmail, setOpenAddEmail] = useState(false);
  const [recipientsSectionOpen, setRecipientsSectionOpen] = useState(true);
  const [openAddCCEmail, setOpenAddCCEmail] = useState(false);
  const [openAddBCCEmail, setOpenAddBCCEmail] = useState(false);
  const [newEmailValue, setNewEmailValue] = useState("");
  const [newCCEmailValue, setNewCCEmailValue] = useState("");
  const [searchText, setSearchText] = useState("");
  const [openDrop, setOpenDrop] = useState(false);
  const [loadingDrop, setLoadingDrop] = useState(false);
  const [selected_files, setSelectedFiles] = useState([]);
  const [selected_folder_files, setSelectedFolderFiles] = useState([]);
  const [folder_documents, setFolderDocuments] = useState([]);
  const [rapport_documents, setRapportDocuments] = useState([]);
  const [reminder_frequency, setReminderFrequency] = useState(5);

  const [loadingGettingExistingEmails, setLoadingGettingExistingEmails] =
    useState(false);
  let dict = {
    logo_url:
      "https://storage.googleapis.com/foundry-2dlu01.appspot.com/logos/se4um6hWlIVKiLxln3gB/ouest_energie_controle_logo.jpg",
    head: {
      number: "20250109000735",
      date: "09/01/2025",
      address: "14 Rue d'Hoëdic Lotissement la Bellangerie-Lot 7 35150 Janzé",
    },
    body: {
      name: "MR DROUIN ",
      content:
        "Atteste sur l’honneur qu’une collerette de conduit de poêle étanche à l’air sera installé, dans la maison de Mr DROUIN située 14 Rue d'Hoëdic Lotissement la Bellangerie-Lot 7au35150 Janzé , pour être en accord avec la règlementation environnementale RE2020",
    },
    sign: {
      city: "Paris",
      date: "09/01/2025",
    },
    footer: "Cordialement, Ouest Energie Contrôle",
  };

  const onDrop = async (files) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);

    setLoadingDrop(false);
  };

  const handleFetchData = async () => {
    let client;
    if (orgData) {
      const token = await getOrRefreshFirebaseToken();
      await getBookShelfUrls(masterData.id, token, prefix);

      const bookshelf = orgData.bookshelf_id
        ? await getDocDataById("bookshelf", orgData.bookshelf_id)
        : null;
      setBookshelf(bookshelf);

      if (folderData) {
        let documents = [];

        if (folderData.documents && folderData.documents.length > 0) {
          const folderDocuments = await getArrayDocDataByID(
            "document",
            folderData.documents.map((doc) => doc.id)
          );
          documents = documents.concat(
            folderDocuments.filter((doc) => doc.files && doc.files.length > 0)
          );
        }

        setFolderDocuments(documents);

        // Fetch rapport slot / payment report files
        let rapportDocs = [];
        try {
          if (folderData.payment_allowed) {
            const paymentsRefs = folderData.reglement?.payments || [];
            for (const paymentRef of paymentsRefs) {
              const paymentData = await getDocDataByRef(paymentRef);
              const rapportFiles = paymentData?.rapport_files || [];
              if (rapportFiles.length > 0) {
                rapportDocs.push({
                  name: paymentData.name || "Rapport paiement",
                  files: rapportFiles,
                });
              }
            }
          } else {
            const slotsRefs = folderData.rapport?.slots || [];
            for (const slotRef of slotsRefs) {
              const slotData = await getDocDataByRef(slotRef);
              const slotFiles = slotData?.files || [];
              if (slotFiles.length > 0) {
                rapportDocs.push({
                  name: slotData.name || "Rapport",
                  files: slotFiles,
                });
              }
            }
          }
        } catch (e) {
          console.error("Error fetching rapport files:", e);
        }
        setRapportDocuments(rapportDocs);
      }

      let email_templates = [];

      const email_filters = [
        {
          field: "org_id",
          operator: "==",
          value: masterData ? masterData.id : orgData.id,
        },
      ];
      email_templates = await queryCollection("email_template", email_filters);
      if (!for_xml) {
        email_templates = email_templates.filter(
          (template) => template.for_xml !== true
        );
      }
      if (!for_doc_request) {
        email_templates = email_templates.filter(
          (template) => template.for_doc_request !== true
        );
      }
      setAllEmailTemplates(email_templates);
      setEmailTemplatesOptions(
        email_templates
          .sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
          .map((template) => {
            return {
              value: template.id,
              label: template.name,
            };
          })
      );

      if (invoiceData) {
        console.log("invoiceData", invoiceData);
        if (invoiceData?.client_id) {
          const client = await getOrgById(invoiceData.client_id);
          emails_options.push({ email: client.email, role: "client" });
        }
        if (invoiceData.client_id) {
          client = await getOrgById(invoiceData.client_id);

          setEmailsOptions([
            {
              email: invoiceData.email_client,
              role: "client",
            },
            {
              email: client.email,
              role: "client",
            },
          ]);
          setEmails([invoiceData.email_client, client.email]);
          setEmailsSelected([invoiceData.email_client, client.email]);
          setReceiverSelected("particulier", client.id);
          setReceiverSelectedObject(
            {
              name: "Particulier " + invoiceData.nom,
              id: "particulier",
              type: "particulier",
              client_type: "particulier",
            },
            {
              name: client.name,
              id: client.id,
              type: "client",
              client_type: client.client_type,
            }
          );
        } else {
          setEmailsOptions([
            {
              email: invoiceData.email_client,
              role: "client",
            },
          ]);
          setEmails([invoiceData.email_client]);
          setEmailsSelected([invoiceData.email_client]);
          setReceiverSelected("particulier");
          setReceiverSelectedObject({
            name: "Particulier " + invoiceData.nom,
            id: "particulier",
            type: "particulier",
            client_type: "particulier",
          });
        }

        let receivers = [
          {
            name: "Particulier " + invoiceData.nom,
            id: "particulier",
            type: "particulier",
            client_type: "particulier",
          },
        ];
        setAllReceivers(receivers);
        setReceiverOptions(
          receivers.map((receiver) => {
            return {
              value: receiver.id,
              label: receiver.name,
              extra_label: "particulier",
            };
          })
        );
      }

      if (folderData) {
        if (folderData.client_type !== "particulier") {
          client = await getOrgById(folderData.client_id);

          setClient(client);
        } else {
          client = {
            name: "Particulier",
            id: "particulier",
            email: folderData.particulier?.email,
            type: "particulier",
          };
          setClient(client);
        }

        if (for_xml) {
          let xml_template = email_templates.find(
            (template) => template.for_xml
          );
          if (xml_template) {
            setEmailTemplateSelected(xml_template.id);
            // add variables to content
            const newObject = addVariables(xml_template.subject_line);
            const newContent = addVariables(xml_template.content);
            setContent(newContent);
            setObject(newObject);
          }
        }

        if (for_doc_request) {
          let doc_template = email_templates.find(
            (template) => template.for_doc_request
          );
          if (doc_template) {
            setEmailTemplateSelected(doc_template.id);
            const newObject = addVariables(doc_template.subject_line);
            let newContent = addVariables(doc_template.content);
            // Replace documents list if template contains placeholder
            if (
              selected_doc_names.length > 0 &&
              newContent.includes("[DOCUMENTS_LIST]")
            ) {
              newContent = replaceDocumentsList(newContent);
            }
            setContent(newContent);
            setObject(newObject);
          } else {
            // Set default content for document request
            setObject("Demande de pièces - " + folderData.nom);
            let defaultContent =
              "Bonjour,\n\nNous avons besoin des documents suivants pour finaliser votre dossier :\n\n[DOCUMENTS_LIST]\n\nMerci de nous transmettre ces pièces dans les meilleurs délais.\n\nCordialement,\n\nL'équipe " +
              masterData.name;
            // Replace documents list if we have selected documents
            if (selected_doc_names.length > 0) {
              defaultContent = replaceDocumentsList(defaultContent);
            }
            setContent(defaultContent);
          }
        }

        let partners = [];
        if (folderData.partners_id) {
          partners = await getArrayDocDataByID("org", folderData.partners_id);
        }
        let receivers = partners;
        if (folderData.marque) {
          // copy client
          if (!folderData.payment_allowed) {
            let client_marque = {
              name: folderData.marque,
              id: client.id,
              users_id: client.users_id,
              client_type: client.client_type,
              type: "client",
            };
            receivers = partners.concat(client_marque);
          } else if (
            folderData.payment_allowed &&
            folderData.client_type !== "particulier"
          ) {
            let client_marque = {
              name: folderData.marque,
              id: client.id,
              users_id: client.users_id,
              client_type: client.client_type,
              type: "client",
            };
            receivers = partners.concat(client_marque);
            receivers = receivers.concat([
              {
                name: "Particulier " + folderData.nom,
                id: "particulier",
                type: "particulier",
                client_type: "particulier",
              },
            ]);
          } else {
            receivers = partners.concat([
              {
                name: "Particulier " + folderData.nom,
                id: "particulier",
                type: "particulier",
                client_type: "particulier",
              },
            ]);
          }
        } else {
          receivers = partners.concat(client);
        }

        setAllReceivers(receivers);
        setReceiverOptions(
          receivers.map((receiver) => {
            return {
              value: receiver.id,
              label: receiver.name,
              extra_label:
                receiver.type === "client"
                  ? "Client professionnel"
                  : receiver.type === "particulier"
                    ? "Client particulier"
                    : "Bureau d'étude",
              type:
                receiver.partner_type === "particulier"
                  ? "purple"
                  : receiver.type === "constructor"
                    ? "indigo"
                    : receiver.type === "expert"
                      ? "green"
                      : "blue",
            };
          })
        );
        // Auto-load all emails from all receivers
        await GetAllEmails(receivers);
      }
    }
  };
  const [searchvalue, setSearchValue] = useState("");
  const handleGetExistingEmails = async (text) => {
    // query among all user collection the emails starting with text
    setLoadingGettingExistingEmails(true);
    setSearchValue(text);
    let all_users;
    let master_users = await getArrayDocDataByID("user", masterData.users_id);
    let client_id = folderData?.client_id || invoiceData?.client_id || null;
    let client;
    let client_users = [];
    if (client_id) {
      client = await getOrgById(folderData?.client_id);
      client_users = await getArrayDocDataByID("user", client?.users_id);
    }
    let partners_id = folderData?.partners_id || [];
    let partners = await getArrayDocDataByID("org", partners_id);
    let partners_users = [];
    for (let partner of partners) {
      let users = await getArrayDocDataByID("user", partner.users_id);
      partners_users = partners_users.concat(users);
    }

    const emails = [
      ...master_users.map((user) => {
        return {
          email: user.email,
          value: user.email,
        };
      }),
      ...client_users.map((user) => {
        return {
          email: user.email,
          value: user.email,
        };
      }),
      ...partners_users.map((user) => {
        return {
          email: user.email,
          value: user.email,
        };
      }),
    ].filter((user) => {
      return (
        user.email.toLowerCase().includes(text.toLowerCase()) ||
        user.value.toLowerCase().includes(text.toLowerCase())
      );
    });

    const emails_options = emails.map((email) => {
      return {
        value: email.email,
        label: email.email,
        extra_label:
          email.role === "particulier"
            ? "Particulier"
            : email.role === "constructor"
              ? "Constructeur"
              : email.role === "expert"
                ? "BE"
                : "Client",
        type:
          email.role === "particulier"
            ? "purple"
            : email.role === "constructor"
              ? "indigo"
              : email.role === "expert"
                ? "green"
                : "blue",
      };
    });
    setExistingEmails(emails_options);
    setLoadingGettingExistingEmails(false);
  };

  const handleChooseReceiver = async (value) => {
    let receiver_object = await getOrgById(value);
    setReceiverSelectedObject(receiver_object);
    setReceiverSelected(value);
    await GetEmails(value);
  };

  const createReminder = async () => {
    let masterid = masterData.id;
    let destorgid = client.id;
    let nom = folderData.nom;
    let due_date = new Date();
    due_date.setDate(
      due_date.getDate() + (for_doc_request ? reminder_frequency : 5)
    );
    let formatted_due_date = due_date.toLocaleDateString("fr-FR");

    let body = {
      folder_ref: folderData.ref,
      org_id: destorgid,
      subject: object,
      html_content: content,
      nom: nom,
      sender_id: masterid,
      date: formatted_due_date,
      trigger_date: getFlutterTimeFromSeconds(due_date.getTime() / 1000),
      counter: 0,
      type: for_doc_request ? "folder_doc" : "xml",
      emails: emails_selected,
      status: "pending",
      frequency: for_doc_request ? reminder_frequency : 5,
    };

    if (for_doc_request) {
      body.folder_docs_id = selected_doc_ids;
    }

    await createDocApi("job", body, prefix);

    handleClickVariant("Rappel programmé", "success");
  };

  const autoSelectEmailsByTemplate = async (templateId) => {
    const preselected = [];
    for (const receiver of all_receivers) {
      if (receiver.id === "particulier") {
        if (folderData?.reglement?.infos?.email) {
          preselected.push(folderData.reglement.infos.email);
        }
        if (invoiceData?.email_client) {
          preselected.push(invoiceData.email_client);
        }
        continue;
      }
      if (!receiver.users_id || receiver.users_id.length === 0) continue;
      for (const user_id of receiver.users_id) {
        const user = await getUserDataById(user_id);
        if (!user || !user.email) continue;
        if (
          user.listen_emails &&
          user.listen_emails.includes(templateId)
        ) {
          if (user.role === "conductor") {
            if (folderData?.conductor_id && user.id === folderData.conductor_id) {
              preselected.push(user.email);
            }
          } else {
            preselected.push(user.email);
          }
        }
      }
    }
    const uniqueEmails = [...new Set(preselected)];
    if (uniqueEmails.length > 0) {
      setEmailsSelected(uniqueEmails);
    }
  };

  const handleChooseTemplate = async (value) => {
    setEmailTemplateSelected(value);
    const themail = all_email_templates.find(
      (template) => template.id === value
    );
    const content = themail.content;
    const subject_line = themail.subject_line;
    setObject(subject_line);
    let newContent = addVariables(content);
    let newObject = addVariables(subject_line);

    if (invoiceData) {
      // add the link to sign the invoice
      const link = ``;
      if (newContent.includes("@lien")) {
        newContent = newContent.replace("@lien", link);
      } else {
        newContent = newContent + "\n\n" + link;
      }
    }

    // Replace documents list for doc requests
    if (
      for_doc_request &&
      selected_doc_names.length > 0 &&
      newContent.includes("[DOCUMENTS_LIST]")
    ) {
      newContent = replaceDocumentsList(newContent);
    }

    setContent(newContent);
    setObject(newObject);

    // Auto-select emails based on template's listen_emails config
    if (emails_options.length > 0) {
      await autoSelectEmailsByTemplate(value);
    }
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const GetEmails = async (receiver_selected, templateId = null) => {
    const activeTemplate = templateId || email_template_selected;
    setGettingEmails(true);
    const emails = [];
    const selected = all_receivers.find(
      (receiver) => receiver.id === receiver_selected
    );

    if (!selected) {
      handleClickVariant("Aucun destinataire sélectionné", "error");
      setGettingEmails(false);
      return;
    }
    let conductor_missed = 0;
    let emails_options = [];

    if (
      receiver_selected !== "particulier" &&
      receiver_selected !== folderData?.client_id
    ) {
      if (selected.users_id && selected.users_id.length > 0) {
        for (let user_id of selected.users_id || []) {
          const user = await getUserDataById(user_id);
          if (!user) continue;
          emails_options.push({ email: user.email, role: user.role });
          if (
            user === null ||
            user.listen_emails === null ||
            user.listen_emails === undefined ||
            !user.listen_emails.includes(activeTemplate)
          ) {
            continue;
          }

          emails.push(user.email);
          emails_options.push({ email: user.email, role: user.role });
        }
      } else {
        handleClickVariant("Ce bureau d'étude n'a aucun utilisateurs", "error");
        setGettingEmails(false);
        return;
      }
    } else {
      if (receiver_selected === "particulier") {
        if (folderData) {
          const particulierEmail =
            folderData?.reglement?.infos?.email ||
            "email non renseigné dans la partie règlement";
          emails_options.push({
            email: particulierEmail,
            role: "particulier",
          });
          if (folderData?.reglement?.infos?.email) {
            emails.push(particulierEmail);
          }
        }
        if (invoiceData) {
          const clientEmail =
            invoiceData?.email_client ||
            "email non renseigné dans la partie règlement";
          emails_options.push({
            email: clientEmail,
            role: "particulier",
          });
          if (invoiceData?.email_client) {
            emails.push(clientEmail);
          }
          // check if the devis was initiated by a professional client and add his email too
        }
      } else {
        for (let user_id of selected.users_id || []) {
          const user = await getUserDataById(user_id);
          if (!user) continue;
          emails_options.push({ email: user.email, role: user.role });
          if (
            user === null ||
            user.listen_emails === null ||
            user.listen_emails === undefined ||
            !user.listen_emails.includes(activeTemplate)
          ) {
            continue;
          }
          if (user.role === "conductor") {
            if (
              folderData?.conductor_id &&
              user.id === folderData?.conductor_id
            ) {
              conductor_missed = -100;
              emails.push(user.email);
            } else {
              conductor_missed += 1;
            }
          } else {
            emails.push(user.email);
          }
        }
      }
    }
    // remove duplicates for emails options
    emails_options = emails_options.filter(
      (email, index, self) =>
        index ===
        self.findIndex((t) => t.email === email.email && t.role === email.role)
    );
    // remove duplicates for emails

    setEmailsOptions(emails_options);

    if (conductor_missed > 0) {
      setConductorMissed(true);
      handleClickVariant(
        "Aucun conducteur n'est affilié au dossier donc aucun conducteur ne peut recevoir cet email",
        "error"
      );
    }

    if (emails.length === 0 && !for_expert) {
      setGettingEmails(false);
      setEmails([]);
      return;
    }
    const uniqueEmails = [...new Set(emails)];
    setEmails(uniqueEmails);
    setEmailsSelected(emails);
    setGettingEmails(false);
  };

  const GetAllEmails = async (receivers) => {
    setGettingEmails(true);
    let all_emails_options = [];

    for (const receiver of receivers) {
      if (receiver.id === "particulier") {
        if (folderData?.reglement?.infos?.email) {
          all_emails_options.push({
            email: folderData.reglement.infos.email,
            role: "particulier",
            source: "Particulier " + (folderData.nom || ""),
          });
        }
        if (invoiceData?.email_client) {
          all_emails_options.push({
            email: invoiceData.email_client,
            role: "particulier",
            source: "Particulier " + (folderData?.nom || ""),
          });
        }
      } else if (receiver.users_id && receiver.users_id.length > 0) {
        for (const user_id of receiver.users_id) {
          const user = await getUserDataById(user_id);
          if (!user || !user.email) continue;
          all_emails_options.push({
            email: user.email,
            role: user.role || "user",
            source: receiver.name || "",
          });
        }
      }
    }

    // Deduplicate by email
    all_emails_options = all_emails_options.filter(
      (email, index, self) =>
        index === self.findIndex((t) => t.email === email.email)
    );

    setEmailsOptions(all_emails_options);
    setGettingEmails(false);
  };

  const [loadingEmail, setLoadingEmail] = useState(false);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const handleSetReminder = async () => {};

  const handleSendEmail = async () => {
    setLoadingEmail(true);
    const token = await getOrRefreshFirebaseToken();
    if (reminder) {
      await createReminder();
    }

    if (!invoiceData) {
      const particulierEmail = folderData?.particulier?.email || folderData?.reglement?.infos?.email;
      const isParticulierSelected = particulierEmail && emails_selected.includes(particulierEmail);
      let prefix_url =
        for_modif_thermal || for_xml || for_expert
          ? "https://web.hexagone.expert/folder/"
          : isParticulierSelected
            ? "https://web.hexagone.expert/folderportal/"
            : "https://web.hexagone.expert/folder/";
      await sendSmartEmailFolder(
        emails_selected,
        cc_emails_selected,
        bcc_emails_selected,
        dropped_files,
        prefix_url,
        content,
        object,
        token,
        "other",
        folderData.id,
        prefix
      );

      const body = {
        object: object,
        content: content,
        date: Timestamp.now(),
        org_id: orgData.id,
        to_org_id: receiver_selected,
        nom: folderData.nom,
        folder_ref: folderData.ref,
        emails: emails_selected,
        files: dropped_files.map((file) => {
          return {
            name: file.name,
          };
        }),
      };
      await createDocApi("email_sent", body, prefix);

      if (for_modif_thermal) {
        let new_modif_thermal = {
          ...folderData.modif_thermal,
          object: object,
          content: content,
        };
        await updateDocDataFieldApi(
          folderData.ref,
          "modif_thermal",
          new_modif_thermal,
          prefix
        );
      }
    } else {
      await sendSmartEmailInvoice(
        emails_selected,
        cc_emails_selected,
        bcc_emails_selected,
        dropped_files,
        content,
        object,
        token,
        invoiceData.id,
        prefix
      );

      const body = {
        object: object,
        content: content,
        date: getFlutterTime(),
        org_id: orgData.id,
        to_org_id: getRefFromId("org", receiver_selected),
        nom: invoiceData.nom,
        invoice_ref: invoiceData.ref,
        emails: emails_selected,
      };
      const email_created = await createDocApi("email_sent", body, prefix);
      let history_events = invoiceData.history_events || [];
      history_events.push({
        date: getFlutterTime(),
        name: "Devis envoyé pour signature",
      });
      await updateDocApi(
        invoiceData.ref,
        {
          history_events: history_events,
          state: "wait",
          last_sent_seconds: getFlutterTime().seconds,
        },
        prefix
      );
    }

    handleClickVariant("Email envoyé", "success");
    setLoadingEmail(false);
    onClose(true);
  };

  function addVariables(content) {
    let variables;
    if (folderData) {
      variables = {
        "@nom": folderData.nom,
        "@ville": folderData.ville,
        "@adresse": folderData.adresse,
        "@postal": folderData.postal,
        "@client": folderData.marque || client.name,
        "@date": eventData
          ? dayjs.unix(eventData.start.seconds).format("DD/MM/YYYY")
          : "",
        "@heure": eventData
          ? dayjs.unix(eventData.start.seconds).format("HH:mm")
          : "",
      };
    } else if (invoiceData) {
      variables = {
        "@nom": invoiceData.nom,
        "@ville": invoiceData.ville,
        "@adresse": invoiceData.adresse,
        "@postal": invoiceData.postal,
        "@client": invoiceData.nom,
        "@lien": `https://web.hexagone.expert/invoice-sign/${invoiceData.id}`,
      };
    }

    let newContent = content;
    for (const [key, value] of Object.entries(variables)) {
      newContent = newContent.replace(key, value);
    }
    return newContent;
  }

  const replaceDocumentsList = (text) => {
    if (for_doc_request && selected_doc_names.length > 0) {
      const docList = selected_doc_names.map((doc) => `- ${doc}`).join("\n");
      return text.replace("[DOCUMENTS_LIST]", docList);
    }
    return text.replace("[DOCUMENTS_LIST]", "");
  };

  useEffect(() => {
    handleFetchData();
  }, [for_expert]);

  useEffect(() => {
    if (
      for_doc_request &&
      selected_doc_names.length > 0 &&
      content.includes("[DOCUMENTS_LIST]")
    ) {
      const replacedContent = replaceDocumentsList(content);
      if (replacedContent !== content) {
        setContent(replacedContent);
      }
    }
  }, [selected_doc_names]);

  // Also trigger replacement when doc request modal opens
  useEffect(() => {
    if (
      for_doc_request &&
      selected_doc_names.length > 0 &&
      content.includes("[DOCUMENTS_LIST]")
    ) {
      setContent(replaceDocumentsList(content));
    }
  }, [for_doc_request]);

  return (
    <div className="flex flex-row  h-screen w-screen justify-center items-center overflow-auto">
      <Modal1
        isOpen={openDrop}
        onClose={(e) => {
          e.stopPropagation();
          setOpenDrop(false);
          setSelectedFolderFiles([]);
        }}
      >
        <div className="bg-white rounded-xl w-fit max-w-full h-fit max-h-[80vh] flex flex-col">
          <div className="text-h2 text-shadow_50 border-b-1 p-4 flex-shrink-0">
            Ajouter des pièces jointes
          </div>
          <div className="flex flex-row gap-4 w-fit bg-neutral-50 p-4 overflow-auto flex-1">
            <div className="w-c400">
              <Dropzone3
                files={dropped_files}
                onDrop={onDrop}
                maxSize={
                  40 * 1024 * 1024 // 40 MB
                }
              ></Dropzone3>
            </div>

            {(bookshelf?.files_clients?.length > 0 ||
              folder_documents?.length > 0 ||
              rapport_documents?.length > 0) && (
              <div className="pl-2 w-c400 p-1 h-fit rounded-lg">
                <div className="flex flex-col gap-4">
                  {bookshelf?.files_clients?.length > 0 && (
                    <div>
                      <div className="text-h3 text-shadow_50 flex flex-row items-center gap-2 mb-4">
                        <Icon1
                          icon_name="bookshelf"
                          size={16}
                          fill="grey"
                        ></Icon1>{" "}
                        Fichiers de la bibliothèque
                      </div>
                      <div className="flex flex-col gap-1">
                        {bookshelf?.files_clients?.map((file, file_index) => (
                          <div
                            key={file_index}
                            className="flex flex-row items-start gap-2"
                          >
                            <CheckBoxGrey
                              onChange={() => {
                                if (selected_files.includes(file)) {
                                  setSelectedFiles(
                                    selected_files.filter((f) => f !== file)
                                  );
                                } else {
                                  setSelectedFiles([...selected_files, file]);
                                }
                              }}
                              checked={selected_files.includes(file)}
                            />
                            <div className="text-h4 text-shadow_50">
                              {file.name.length > 45
                                ? file.name.slice(0, 45) + "..."
                                : file.name}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {folder_documents?.length > 0 && (
                    <div>
                      <div className="text-h3 text-shadow_50 flex flex-row items-center gap-2 mb-4">
                        <Icon1 icon_name="folder" size={16} fill="grey"></Icon1>{" "}
                        Fichiers du dossier
                      </div>
                      <div className="flex flex-col gap-2">
                        {folder_documents.map((doc, doc_index) => (
                          <div key={doc_index} className="flex flex-col gap-1">
                            <div className="text-h4 font-semibold text-shadow_75 mb-1">
                              {doc.name ||
                                doc.title ||
                                `Document ${doc_index + 1}`}
                            </div>
                            {doc.files?.map((file, file_index) => (
                              <div
                                key={`${doc_index}-${file_index}`}
                                className="flex flex-row items-start gap-2 ml-2"
                              >
                                <CheckBoxGrey
                                  onChange={() => {
                                    if (selected_folder_files.includes(file)) {
                                      setSelectedFolderFiles(
                                        selected_folder_files.filter(
                                          (f) => f !== file
                                        )
                                      );
                                    } else {
                                      setSelectedFolderFiles([
                                        ...selected_folder_files,
                                        file,
                                      ]);
                                    }
                                  }}
                                  checked={selected_folder_files.includes(file)}
                                />
                                <div className="text-h4 text-shadow_50">
                                  {file.name.length > 45
                                    ? file.name.slice(0, 45) + "..."
                                    : file.name}
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {rapport_documents?.length > 0 && (
                    <div>
                      <div className="text-h3 text-shadow_50 flex flex-row items-center gap-2 mb-4">
                        <Icon1 icon_name="description" size={16} fill="grey"></Icon1>{" "}
                        Fichiers de rapport
                      </div>
                      <div className="flex flex-col gap-2">
                        {rapport_documents.map((doc, doc_index) => (
                          <div key={doc_index} className="flex flex-col gap-1">
                            <div className="text-h4 font-semibold text-shadow_75 mb-1">
                              {doc.name}
                            </div>
                            {doc.files?.map((file, file_index) => (
                              <div
                                key={`rapport-${doc_index}-${file_index}`}
                                className="flex flex-row items-start gap-2 ml-2"
                              >
                                <CheckBoxGrey
                                  onChange={() => {
                                    if (selected_folder_files.includes(file)) {
                                      setSelectedFolderFiles(
                                        selected_folder_files.filter(
                                          (f) => f !== file
                                        )
                                      );
                                    } else {
                                      setSelectedFolderFiles([
                                        ...selected_folder_files,
                                        file,
                                      ]);
                                    }
                                  }}
                                  checked={selected_folder_files.includes(file)}
                                />
                                <div className="text-h4 text-shadow_50">
                                  {file.name.length > 45
                                    ? file.name.slice(0, 45) + "..."
                                    : file.name}
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-row justify-end gap-2 p-4 border-t-1 flex-shrink-0">
            <PrimaryButton
              className={"w-fit self-end"}
              onClick={() => {
                setOpenDrop(false);
                setDroppedFiles(
                  dropped_files
                    .concat(selected_files)
                    .concat(selected_folder_files)
                );
                setSelectedFiles([]);
                setSelectedFolderFiles([]);
              }}
            >
              Enregistrer
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={openAddEmail}
        onClose={(e) => {
          e.stopPropagation();
          setOpenAddEmail(false);
        }}
      >
        <div className="flex flex-col gap-2 w-c400 h-fit bg-white p-4 rounded-3xl">
          <TextField2T
            label={"Ajouter un email"}
            value={newEmailValue}
            type="email"
            mandatory={true}
            onChange={(e) => setNewEmailValue(e.target.value)}
          ></TextField2T>
          <div className="flex flex-row gap-2 justify-end">
            <SecondaryButton
              onClick={(e) => {
                e.stopPropagation();
                setOpenAddEmail(false);
              }}
            >
              Annuler
            </SecondaryButton>
            <PrimaryButton
              onClick={() => {
                setEmails(emails.concat(newEmailValue));
                setEmailsSelected(emails_selected.concat(newEmailValue));
                setEmailsOptions(
                  emails_options.concat({
                    email: newEmailValue,
                    role: "client",
                  })
                );
                setGettingEmails(false);
                setNewEmailValue("");
                setOpenAddEmail(false);
              }}
            >
              Ajouter
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={openAddCCEmail}
        onClose={(e) => {
          e.stopPropagation();
          setOpenAddCCEmail(false);
        }}
      >
        <div className="flex flex-col gap-2 w-c400 h-fit bg-white p-4 rounded-3xl">
          <DropDownGPTS3
            label={"Ajouter un email"}
            value={newCCEmailValue}
            loadingSearch={loadingGettingExistingEmails}
            onSearchChange={(text) => handleGetExistingEmails(text)}
            items={existing_emails}
            onChange={(e) => {
              setNewCCEmailValue(e.value);
            }}
            hasMoreOptions={true}
          ></DropDownGPTS3>
          <div className="flex flex-row gap-2 justify-end">
            <SecondaryButton
              onClick={(e) => {
                e.stopPropagation();
                setNewCCEmailValue("");
                setGettingEmails(false);
                setOpenAddCCEmail(false);
              }}
            >
              Annuler
            </SecondaryButton>
            <PrimaryButton
              onClick={() => {
                let value =
                  newCCEmailValue.length > 0 ? newCCEmailValue : searchvalue;
                setCcEmails(cc_emails.concat(value));
                setCcEmailsSelected(cc_emails_selected.concat(value));
                setCcEmailsOptions(
                  cc_emails_options.concat({
                    email: value,
                    role: "client",
                  })
                );

                setGettingEmails(false);
                setNewCCEmailValue("");
                setOpenAddCCEmail(false);
              }}
            >
              Ajouter
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={openAddBCCEmail}
        onClose={(e) => {
          e.stopPropagation();
          setOpenAddBCCEmail(false);
        }}
      >
        <div className="flex flex-col gap-2 w-c400 h-fit bg-white p-4 rounded-3xl">
          <DropDownGPTS3
            label={"Ajouter un email"}
            value={newCCEmailValue}
            loadingSearch={loadingGettingExistingEmails}
            onSearchChange={(text) => handleGetExistingEmails(text)}
            items={existing_emails}
            onChange={(e) => {
              setNewCCEmailValue(e.value);
            }}
            hasMoreOptions={true}
          ></DropDownGPTS3>
          <div className="flex flex-row gap-2 justify-end">
            <SecondaryButton
              onClick={(e) => {
                e.stopPropagation();
                setOpenAddBCCEmail(false);
              }}
            >
              Annuler
            </SecondaryButton>
            <PrimaryButton
              onClick={() => {
                let value =
                  newCCEmailValue.length > 0 ? newCCEmailValue : searchvalue;
                setBccEmails(cc_emails.concat(value));
                setBccEmailsSelected(cc_emails_selected.concat(value));
                setBccEmailsOptions(
                  bcc_emails_options.concat({
                    email: value,
                    role: "client",
                  })
                );
                setGettingEmails(false);
                setNewCCEmailValue("");
                setOpenAddBCCEmail(false);
              }}
            >
              Ajouter
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <div
        onClick={(e) => e.stopPropagation()}
        className=" flex
     bg-white shadow-md rounded-xl w-full max-w-[75vw]  h-[90vh] max-h-[90vh] overflow-auto  p-2  "
      >
        {" "}
        <div className="flex flex-col   w-full">
          <div className="flex flex-row justify-startn  items-center gap-2  w-full rounded-t-2xl p-4 ">
            <div className="text-h1 font-semibold mr-auto">Nouveau message</div>
            {!workspaceData && (
              <SecondaryButton onClick={() => navigateWorkspace("/email")}>
                Configurer mes modèles
              </SecondaryButton>
            )}
            <SecondaryButton onClick={() => onClose(true)}>
              Annuler
            </SecondaryButton>
          </div>{" "}
          <div className="flex flex-col h-full overflow-auto px-4 pb-4 w-full ">
            <div className="flex flex-col gap-2 w-full h-fit">
              {for_modif_thermal && (
                <div className="flex flex-col justify-between gap-2 w-fit px-2 py-1 text-indigo-500 bg-indigo-50 border-l-2 border-indigo-300 rounded-lg">
                  <div className="text-h3 ">
                    Demande de mise à jour thermique
                  </div>
                </div>
              )}
              {for_xml && (
                <div className="flex flex-col justify-between gap-2 w-fit px-2 py-1 text-indigo-500 bg-indigo-50 border-l-2 border-indigo-300 rounded-lg">
                  <div className="text-h3 ">Demande de XML</div>
                </div>
              )}
              {for_doc_request && (
                <div className="flex flex-col justify-between gap-2 w-fit px-2 py-1 text-green-500 bg-green-50 border-l-2 border-green-300 rounded-lg">
                  <div className="text-h3 ">Demande des pièces</div>
                </div>
              )}{" "}
              {invoiceData && (
                <div className="flex flex-col justify-between gap-2 w-fit px-2 py-1 text-indigo-500 bg-indigo-50 border-l-2 border-indigo-300 rounded-lg">
                  <div className="text-h3 ">Signature du devis</div>
                </div>
              )}
              <div className="flex flex-row gap-2 items-center flex-1 ">
                <DropDownGPTS3
                  label={"Choisir le modèle d'email"}
                  items={email_templates_options}
                  className="w-full"
                  mandatory={!for_doc_request}
                  onChange={(e) => handleChooseTemplate(e.value)}
                  value={email_template_selected}
                ></DropDownGPTS3>
              </div>
              {for_doc_request && selected_doc_names.length > 0 && (
                <div className="flex flex-row gap-2 items-center">
                  <div className="text-h3 text-shadow_50">
                    Documents sélectionnés: {selected_doc_names.join(", ")}
                  </div>
                </div>
              )}
              <div className="flex flex-col gap-2 h-fit">
                {emails_options.length === 0 &&
                  !gettingEmails &&
                  !for_expert &&
                  orgData?.id === folderData?.master_id && (
                    <div className="flex flex-col h-fit justify-between gap-2 w-full p-2 text-orange-500 bg-orange-50 border-l-2 border-orange-300 rounded-lg">
                      {conductor_missed && (
                        <div className="text-h4 ">
                          Aucun conducteur n'est affilié au dossier donc aucun
                          conducteur ne peut recevoir cet email
                        </div>
                      )}
                      {!conductor_missed && !for_expert && (
                        <div className="h-fit">
                          <div className="text-h4 ">
                            Pour ce type d'email, ce partenaire n'a aucun
                            destinataire configuré par défaut.
                          </div>
                          <div className="text-h4 ">
                            Vous pouvez ajouter des destinataires pour cet email
                            dans la fiche du partenaire (client ou bureau
                            d'étude).
                          </div>

                          <SecondaryButton
                            className="w-fit"
                            onClick={() =>
                              navigateWorkspace("/partner/" + receiver_selected)
                            }
                          >
                            Voir fiche partenaire
                          </SecondaryButton>
                        </div>
                      )}
                    </div>
                  )}
              </div>
              {(
                <div className="h-fit flex flex-col gap-1">
                  <div
                    className="flex flex-row items-center gap-2 cursor-pointer select-none"
                    onClick={() => setRecipientsSectionOpen(!recipientsSectionOpen)}
                  >
                    <div className="text-h3 font-semibold text-shadow_75">
                      Destinataires ({emails_selected.length})
                    </div>
                    <svg
                      className={`w-4 h-4 text-gray-400 transition-transform ${recipientsSectionOpen ? "rotate-180" : ""}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                    {!recipientsSectionOpen && emails_selected.length > 0 && (
                      <div className="text-h4 text-gray-400 truncate max-w-[400px]">
                        {emails_selected.join(", ")}
                      </div>
                    )}
                    {recipientsSectionOpen && (emails_selected.length > 0 || cc_emails_selected.length > 0 || bcc_emails_selected.length > 0) && (
                      <div
                        className="text-xs text-red-500 cursor-pointer hover:underline ml-auto"
                        onClick={(e) => {
                          e.stopPropagation();
                          setEmailsSelected([]);
                          setCcEmailsSelected([]);
                          setBccEmailsSelected([]);
                        }}
                      >
                        Tout décocher
                      </div>
                    )}
                  </div>
                  {recipientsSectionOpen && (
                    <div className="flex flex-col gap-2 mt-1">
                      <div className="flex flex-row items-start gap-4">
                        <div className="text-h3 text-shadow_50 mr-3 mt-1">Des</div>
                        <div className="flex flex-col gap-2 flex-1">
                          <SmallSpinner loading={gettingEmails} />
                          {Object.entries(
                            emails_options.reduce((groups, email) => {
                              const key = email.source || "Autre";
                              if (!groups[key]) groups[key] = [];
                              groups[key].push(email);
                              return groups;
                            }, {})
                          ).map(([source, sourceEmails]) => (
                            <div key={source} className="flex flex-col gap-0.5">
                              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                {source}
                              </div>
                              <div className="flex flex-wrap gap-1">
                                {sourceEmails.map((email, index) => (
                                  <div
                                    key={index}
                                    className={`flex h-fit justify-between ${email.role === "conductor" ? "bg-red-50" : email.role === "particulier" ? "bg-purple-50" : "bg-indigo-50"} rounded-md px-2 py-0.5 cursor-pointer`}
                                    onClick={() => {
                                      if (email.email === "email non renseigné dans la partie règlement") return;
                                      if (emails_selected.includes(email.email)) {
                                        setEmailsSelected(emails_selected.filter((item) => item !== email.email));
                                      } else {
                                        setEmailsSelected([...emails_selected, email.email]);
                                      }
                                    }}
                                  >
                                    <div className="text-h4 text-shadow_50 flex flex-row gap-2 items-center">
                                      <CheckBoxGrey
                                        checked={emails_selected.includes(email.email)}
                                        disabled={email.email === "email non renseigné dans la partie règlement"}
                                        onChange={() => {
                                          if (email.email === "email non renseigné dans la partie règlement") return;
                                          if (emails_selected.includes(email.email)) {
                                            setEmailsSelected(emails_selected.filter((item) => item !== email.email));
                                          } else {
                                            setEmailsSelected([...emails_selected, email.email]);
                                          }
                                        }}
                                      />
                                      <span className={`select-text ${email.email === "email non renseigné dans la partie règlement" ? "text-red-500 bg-red-100 px-2 py-0.5" : ""}`}>
                                        {email.email}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                          <SecondaryButton
                            onClick={() => setOpenAddEmail(true)}
                            className={"h-6 w-fit"}
                          >
                            Ajouter
                          </SecondaryButton>
                        </div>
                      </div>
                  <div className="flex flex-wrap items-center gap-4">
                    <div className="flex flex-row items-center gap-4">
                      <div className="text-h3 text-shadow_50 mr-4">Cc </div>
                      <div className="flex flex-wrap gap-1 h-fit mt-1">
                        {cc_emails_options.map((email, index) => (
                          <div
                            key={index}
                            className={`flex flex- h-fit justify-between ${email.role === "conductor" ? "bg-red-50" : "bg-blue-50"} rounded-md px-2 py-0.5 cursor-pointer`}
                            onClick={() => {
                              if (email.email === "email non renseigné dans la partie règlement") return;
                              if (cc_emails_selected.includes(email.email)) {
                                setCcEmailsSelected(cc_emails_selected.filter((item) => item !== email.email));
                              } else {
                                setCcEmailsSelected([...cc_emails_selected, email.email]);
                              }
                            }}
                          >
                            <div className="text-h4 text-shadow_50 flex flex-row gap-2 items-center">
                              <CheckBoxGrey
                                checked={cc_emails_selected.includes(
                                  email.email
                                )}
                                disabled={
                                  email.email ===
                                  "email non renseigné dans la partie règlement"
                                }
                                onChange={() => {
                                  if (email.email === "email non renseigné dans la partie règlement") return;
                                  if (cc_emails_selected.includes(email.email)) {
                                    setCcEmailsSelected(cc_emails_selected.filter((item) => item !== email.email));
                                  } else {
                                    setCcEmailsSelected([...cc_emails_selected, email.email]);
                                  }
                                }}
                              />
                              <span
                                className={`select-text ${email.email === "email non renseigné dans la partie règlement" ? "text-red-500 bg-red-100 px-2 py-0.5" : ""}`}
                              >
                                {email.email}
                              </span>
                            </div>
                          </div>
                        ))}
                        <SecondaryButton
                          onClick={() => setOpenAddCCEmail(true)}
                          className={"h-6"}
                        >
                          Ajouter
                        </SecondaryButton>
                      </div>{" "}
                    </div>
                    <div className="flex flex-row items-center gap-4">
                      <div className="text-h3 text-shadow_50 mr-4">Bcc </div>
                      <div className="flex flex-wrap gap-1 h-fit mt-1">
                        {bcc_emails_options.map((email, index) => (
                          <div
                            key={index}
                            className={`flex flex- h-fit justify-between ${email.role === "conductor" ? "bg-red-50" : "bg-blue-50"} rounded-md px-2 py-0.5 cursor-pointer`}
                            onClick={() => {
                              if (email.email === "email non renseigné dans la partie règlement") return;
                              if (bcc_emails_selected.includes(email.email)) {
                                setBccEmailsSelected(bcc_emails_selected.filter((item) => item !== email.email));
                              } else {
                                setBccEmailsSelected([...bcc_emails_selected, email.email]);
                              }
                            }}
                          >
                            <div className="text-h4 text-shadow_50 flex flex-row gap-2 items-center">
                              <CheckBoxGrey
                                checked={bcc_emails_selected.includes(
                                  email.email
                                )}
                                disabled={
                                  email.email ===
                                  "email non renseigné dans la partie règlement"
                                }
                                onChange={() => {
                                  if (email.email === "email non renseigné dans la partie règlement") return;
                                  if (bcc_emails_selected.includes(email.email)) {
                                    setBccEmailsSelected(bcc_emails_selected.filter((item) => item !== email.email));
                                  } else {
                                    setBccEmailsSelected([...bcc_emails_selected, email.email]);
                                  }
                                }}
                              />
                              <span
                                className={`select-text ${email.email === "email non renseigné dans la partie règlement" ? "text-red-500 bg-red-100 px-2 py-0.5" : ""}`}
                              >
                                {email.email}
                              </span>
                            </div>
                          </div>
                        ))}
                        <SecondaryButton
                          onClick={() => setOpenAddBCCEmail(true)}
                          className={"h-6 w-6 "}
                        >
                          Ajouter
                        </SecondaryButton>
                      </div>
                    </div>
                  </div>
                  </div>
                  )}
                  <div className="flex flex-row items-center gap-4">
                    <div className="text-h3 text-shadow_50 mr-4">
                      <Icon1 icon_name="join" size={16} fill="grey"></Icon1>
                    </div>
                    <div className="flex flex-wrap gap-1 h-fit mt-1">
                      {dropped_files.map((file, index) => (
                        <div
                          key={index}
                          className={`flex flex- h-fit justify-between bg-indigo-50 rounded-md px-2 py-0.5 `}
                        >
                          <div className="text-h4 text-indigo-400 flex flex-row gap-2 items-center">
                            <Icon1
                              icon_name="file"
                              size={18}
                              fill="#818cf8"
                            ></Icon1>{" "}
                            <span className={``}>{file.name}</span>{" "}
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                setDroppedFiles(
                                  dropped_files.filter(
                                    (f) => f.name !== file.name
                                  )
                                )
                              }
                            >
                              <Icon1
                                icon_name="delete"
                                size={14}
                                fill="grey"
                              ></Icon1>
                            </div>
                          </div>
                        </div>
                      ))}
                      <SecondaryButton
                        onClick={() => setOpenDrop(true)}
                        className={"h-6"}
                      >
                        Ajouter
                      </SecondaryButton>
                    </div>{" "}
                  </div>
                </div>
              )}
            </div>
            <div className="w-full h-fit border-t-1 border-shadow_5 mb-2 mt-4"></div>
            <div className="flex flex-col  w-full h-full ">
              <TextField2
                noborder={true}
                label={"Objet"}
                className=" font-semibold"
                value={object}
                onChange={(e) => setObject(e.target.value)}
              ></TextField2>
              <div className="w-full  border-t-1 border-shadow_5 my-2"></div>
              <div className="h-full min-h-[300px] max-h-[50vh]">
                <TextFieldEmail
                  noborder={true}
                  className="h-full max-h-full  rounded-3xl"
                  label={"Contenu"}
                  value={content}
                  rows={20}
                  onChange={(e) => {
                    setContent(e.target.value);
                    if (recipientsSectionOpen) setRecipientsSectionOpen(false);
                  }}
                  onFocus={() => {
                    if (recipientsSectionOpen) setRecipientsSectionOpen(false);
                  }}
                ></TextFieldEmail>
              </div>
              <div className="w-full  border-t-1 border-shadow_5 my-2"></div>

              {for_xml && (
                <div className="flex flex-col gap-1 w-c400">
                  {" "}
                  <div className="text-h2 flex flex-row gap-2">
                    Rappels{" "}
                    <Icon1 icon_name="horloge" fill="grey" size={20}></Icon1>
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    <EasySwitch
                      checked={reminder}
                      onChange={(checked) => setReminder(checked)}
                    />
                    <div className="text-h3 text-shadow_50">
                      Rappel automatique tous les 5 jours
                    </div>
                  </div>{" "}
                  <div className="text-h3 text-shadow_50">
                    Si votre partenaire oublie d'effectuer l'action, des emails
                    de rappels seront envoyés automatiquement.
                  </div>
                </div>
              )}

              {for_doc_request && (
                <div className="flex flex-col gap-1 w-c400">
                  <div className="text-h2 flex flex-row gap-2">
                    Rappels{" "}
                    <Icon1 icon_name="horloge" fill="grey" size={20}></Icon1>
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    <EasySwitch
                      checked={reminder}
                      onChange={(checked) => setReminder(checked)}
                    />
                    <div className="text-h3 text-shadow_50">
                      Rappel automatique tous les
                    </div>
                    <input
                      type="number"
                      min="5"
                      value={reminder_frequency}
                      onChange={(e) =>
                        setReminderFrequency(
                          Math.max(5, parseInt(e.target.value) || 5)
                        )
                      }
                      className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                    />
                    <div className="text-h3 text-shadow_50">jours</div>
                  </div>
                  <div className="text-h3 text-shadow_50">
                    Si votre partenaire oublie d'envoyer les documents, des
                    emails de rappels seront envoyés automatiquement (minimum 5
                    jours).
                  </div>
                </div>
              )}

              <div className="flex flex-col items-end mt-2">
                <PrimaryButton
                  onClick={handleSendEmail}
                  disabled={false}
                >
                  Envoyer l'email
                  <SmallSpinner loading={loadingEmail} margin={6} />
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailModal;
